import SpeakerDashboardView from "@/views/speaker/dashboard/DashboardView";

export default [
  {
    name: "pages.speaker.dashboard",
    path: "dashboard",
    component: SpeakerDashboardView
  },
  
];
